import { render, staticRenderFns } from "./ManualExtService.vue?vue&type=template&id=4f8de8c5&scoped=true&"
import script from "./ManualExtService.vue?vue&type=script&lang=js&"
export * from "./ManualExtService.vue?vue&type=script&lang=js&"
import style0 from "./ManualExtService.vue?vue&type=style&index=0&id=4f8de8c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8de8c5",
  null
  
)

export default component.exports